import Vue from "vue";
import Vuex, { GetterTree, MutationTree, ActionTree } from "vuex";

// *** Interface
import { userData } from "@/interfaces/user.interface";

Vue.use(Vuex);

class State {
  userUID: string | null = null;
  userData: userData | null = null;
}

const getters = <GetterTree<State, any>>{
  getUserUID(state): string | null {
    return state.userUID;
  },
  getUserData(state): userData | null {
    return state.userData;
  },
  isUserSignedIn(state): boolean {
    if (state.userUID && state.userData) return true;
    return false;
  },
};

const mutations = <MutationTree<State>>{
  setUserUID(state, payload: string | null) {
    state.userUID = payload;
  },

  setUserData(state, payload: userData | null) {
    state.userData = payload;
  },
};

const actions = <ActionTree<State, any>>{};

const userStore = {
  namespace: true,
  getters: getters,
  state: new State(),
  mutations: mutations,
  actions: actions,
};

export default userStore;
